import * as React from 'react';

import { humanizeLearningTime } from 'js/utils/DateTimeUtils';

import { VisuallyHidden } from '@coursera/cds-core';

type Props = {
  className?: string;
  timeCommitment: number;
};

const TimeCommitmentEffortText = ({ className, timeCommitment, ...rest }: Props) =>
  timeCommitment ? (
    <span className={className} {...rest}>
      <VisuallyHidden component="span" className="rc-A11yScreenReaderOnly">
        . Duration: {humanizeLearningTime(timeCommitment, true)}
      </VisuallyHidden>
      <span aria-hidden={true}>{humanizeLearningTime(timeCommitment)}</span>
    </span>
  ) : null;

export default TimeCommitmentEffortText;
